import React, {useEffect, useRef, useState} from "react";
import associateServices from "../../../../services";
import Big from "big.js";
import {useSelector} from "react-redux";
import Loading from "../../../../components/loading";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import NoData from "../../../../components/no-data";
import SvgIcon from "../../../../components/svg-icon";
import SlimSelect from "slim-select";

let select;
let typeSelect;
const INITIAL_STATE = {
    total_bet_count: '',
    total_loses_count: '',
    total_wager_amount: '',
    total_win_count: '',
}
const list = [
    {code: 'all', name: 'All', balance: 0},
    {code: 'TRY', name: 'TRY', balance: 0},
    {code: 'BTC', name: 'Bitcoin', balance: 0},
    {code: 'LTC', name: 'Litecoin', balance: 0},
    {code: 'DOGE', name: 'Dogecoin', balance: 0},
    {code: 'TRX', name: 'Tron', balance: 0},
    {code: 'USDT', name: 'USDT', balance: 0},
    {code: 'ETH', name: 'ETH', balance: 0},
    {code: 'BNB', name: 'BNB', balance: 0},
    {code: 'USDC', name: 'USDC', balance: 0},
    {code: 'LINK', name: 'LINK', balance: 0},
    {code: 'SHIB', name: 'SHIB', balance: 0},
    {code: 'XRP', name: 'XRP', balance: 0},
    {code: 'AVAX', name: 'AVAX', balance: 0},
    {code: 'ADA', name: 'ADA', balance: 0},
]
const Stats = props => {
    let {username} = props
    const {t} = useTranslation()
    const {user} = useSelector(state => state.authenticationReducer)
    const [stats, setStats] = useState(INITIAL_STATE)
    const [loading, setLoading] = useState(true)
    const [requesting, setRequesting] = useState(false)
    const [currencyListFiltered, setCurrencyListFiltered] = useState([])
    const [search, setSearch] = useState('')
    const [currency, setCurrency] = useState('all')
    const [error, setError] = useState(false)
    const [stateUsername, setStateUsername] = useState('')
    const [selectedType, setSelectedType] = useState('casino')


    useEffect(() => {
        setStateUsername(username ?? user?.username)
    }, [username, user?.username])

    useEffect(() => {


        setCurrencyListFiltered(list?.filter(i => i.code?.toUpperCase().includes(search?.toUpperCase()) || i.name?.toUpperCase().includes(search?.toUpperCase())))

    }, [search])


    useEffect(() => {
        const dt = currencyListFiltered?.map(item => ({
            text: item.code === 'all' ? t('general.all') : item.name,
            value: item.code
        }))
        select?.setData(dt)
    }, [currencyListFiltered])


    useEffect(() => {
        select = new SlimSelect({
            select: '#currency',
            settings: {
                showSearch: false,
            },
            events: {
                afterChange: newVal => setCurrency(newVal[0]?.value),
            }
        })


        typeSelect = new SlimSelect({
            select: '#type',
            settings: {
                showSearch: false,
            },
            events: {
                afterChange: newVal => setSelectedType(newVal[0]?.value),
            }
        });


    }, [])

    useEffect(() => {
        if (stateUsername) {
            setLoading(true)
            associateServices
                .getBasicStats(stateUsername, selectedType, currency)
                .then(res => {
                    if (res?.status === 200)
                        setStats(res?.data || INITIAL_STATE)
                    else
                        setError(res?.errors)
                    setLoading(false)
                })
        }
    }, [currency, selectedType, stateUsername])


    const handleRequestStatisticsDownload = () => {
        setRequesting(true)
        associateServices.requestDownload({
            currency,
            type: 'casino',
            model: 'statistic'
        }).then(res => {
            setRequesting(false)

            return toast.info(t(`api-notifications.${res?.data || res?.errors}`))
        })
    }
    return (
        <div
            className="tab-pane fade show active">
            <div className="row">
                <div className="col-6 col-md-6">
                    <div className="form__group">
                        <label htmlFor="" className="form__label">
                            {t('modals.statistics.type')}
                        </label>
                        <select name="" id="type" className="form__select">
                            <option value={'all'}>
                                {t('general.all')}
                            </option>
                            <option value={'casino'}>
                                {t('modals.statistics.casino')}
                            </option>
                            <option value={'sportsbook'}>
                                {t('modals.statistics.sportsbook')}
                            </option>
                        </select>
                    </div>
                </div>
                <div className="col-6 col-md-6">
                    <div className="form__group">
                        <label htmlFor="" className="form__label">
                            {t('modals.statistics.currency')}
                        </label>
                        <select name="" id="currency" className="form__select"/>
                    </div>
                </div>
                {
                    loading ? <Loading/> :

                        error ?
                            <NoData desc={t(`api-notifications.${error}`)}/>
                            :
                            <>
                                <div className="col-6 col-md-6">
                                    <div className="stat stat--blue">
                                        <h6 className="stat__title">
                                            {t('modals.statistics.total-bets')}

                                        </h6>
                                        <p className="stat__value">{
                                            Big(stats.total_bet_count || 0).toFixed(2)
                                        }</p>
                                    </div>
                                </div>
                                <div className="col-6 col-md-6">
                                    <div className="stat stat--purple">
                                        <h6 className="stat__title">
                                            {t('modals.statistics.number-of-wins')}

                                        </h6>
                                        <p className="stat__value">{
                                            Big(stats.total_win_count || 0).toFixed(2)
                                        }</p>
                                    </div>
                                </div>
                                <div className="col-6 col-md-6">
                                    <div className="stat stat--orange">
                                        <h6 className="stat__title">
                                            {t('modals.statistics.number-of-losses')}
                                        </h6>
                                        <p className="stat__value">{
                                            Big(stats.total_loses_count || 0).toFixed(2)
                                        }</p>
                                    </div>
                                </div>
                                <div className="col-6 col-md-6">

                                    <div className="stat stat--green">
                                        <h6 className="stat__title">
                                            {t('modals.statistics.wagered')}

                                        </h6>
                                        <p className="stat__value">$
                                            {Big(stats.total_wager_amount || 0).toFixed(2)}
                                        </p>
                                    </div>
                                </div>
                            </>
                }

                <div className="col-12">
                    {
                        username === user?.username &&
                        <button
                            disabled={requesting}
                            onClick={handleRequestStatisticsDownload}
                            className="modal__download" type="button">
                            <SvgIcon id={'download'}/>
                            {t('modals.statistics.request')}
                        </button>
                    }
                </div>
            </div>
        </div>

    )

}

export default Stats
